export const TYPE = {
  MP: 'MP',
  MP_WOW: 'MP_WOW',
  NESS: 'NESS',
  NBOX: 'NBOX',
  MSHOP: 'MSHOP',
};
